import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { TutorialContext } from "../../../../contexts/TutorialContext";
import { Step } from "react-joyride";

import loggerImage from "../../../../assets/TaggingLoggerScreenshot.png"
import editorImage from "../../../../assets/EditorScreenshot.png"

export function useSteps() {
  const { tutorialRefs } = useContext(TutorialContext);
  const {
    helpButtonRef,
    newPentestButtonRef,
    newPentestFormRef,
    sidebarRef,
    tokenBoxRef,
    editorButtonRef,
    exportPdfRef,
    refreshListRef,
    searchListRef,
    toggleTokenRef,
  } = tutorialRefs;
  const { pathname } = useLocation();

  let steps: Step[] = [];
  if (pathname === "/" || pathname === "/dashboard")
    steps = [
      {
        target: "body",
        title: "Welcome to Pentra!",
        content: "This is a quick tutorial to show you around our interface.",
        placement: "center",
        disableBeacon: true,
        data: {
          next: true,
          skip: true,
        },
      },
      {
        target: helpButtonRef.current ?? "",
        content: "This tutorial can be toggled at any time, by clicking the help button in the corner of that page.",
        placement: "top-end",
        data: {
          next: true,
          back: true,
          skip: true,
        },
      },
      {
        target: newPentestButtonRef.current ?? "",
        content: "First, create a new pentest to get started.",
        placement: "bottom",
      },
      {
        target: newPentestFormRef.current ?? "",
        content: "Take your time to fill out the form - this data will appear on the final report.",
        placement: "left",
      },
      {
        target: "#open-pentest-button",
        content: "Finally, click this button to open up the pentest in the Pentest Interface.",
        placement: "bottom",
      },
    ];
  else if (pathname === "/pentest")
    steps = [
      {
        target: "body",
        title: "Pentest Interface",
        content:
          "This is the place where you'll spend most of your time - logging commands, generating and editing vulns, and exporting to PDF.",
        placement: "center",
        disableBeacon: true,
        data: {
          next: true,
          skip: true,
        },
      },
      {
        target: sidebarRef.current ?? "",
        title: "Sidebar",
        content:
          "You can find all important actions here. You'll also use the sidebar to switch tabs, but we'll come back to that later.",
        placement: "right",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: tokenBoxRef.current ?? "",
        title: "Token",
        content: "Your token will appear here if you don't have any logged commands.",
        placement: "bottom",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: toggleTokenRef.current ?? "",
        title: "Token",
        content: "Toggle the token on or off here.",
        placement: "bottom",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: refreshListRef.current ?? "", 
        title: "Refresh",
        content: "Fetch newly logged commands here.",
        placement: "bottom",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: searchListRef.current ?? "",
        title: "Search",
        content: "You can search logged commands here.",
        placement: "bottom",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: "body",
        title: "Tagging",
        content: "Mark vulnerabilities by selecting vulnerable commands once they appear and adding them to a vulnerability. Each vuln is a separate section in the report.",
        placement: "center",
        data: {
          back: true,
          next: true,
          image: loggerImage,
        },
      },
      {
        target: editorButtonRef.current ?? "",
        title: "Editor",
        content: "Let's also quickly go over to the editor.",
        placement: "right",
      },
      {
        target: "body",
        title: "Editor",
        content: "As you add new pieces to your report, you can always come here and edit them as you wish.",
        placement: "center",
        data: {
          next: true,
          image: editorImage,
        },
      },
      {
        target: exportPdfRef.current ?? "",
        title: "Template",
        content: "Once you have vulnerabilities in your report, you can edit your template here, and export to PDF.",
        placement: "right",
        data: {
          back: true,
          next: true,
        },
      },
      {
        target: "body",
        title: "",
        content:
          "This is the end of the tutorial. We hope you enjoy using Pentra, and don't hesitate to send feedback our way!",
        placement: "center",
        data: {
          back: true,
          next: true,
        },
      },
    ];
  else if (pathname === "/account" || pathname === "/settings") steps = [];
  else steps = [];

  return steps;
}
